// extracted by mini-css-extract-plugin
export default {"agenda":"e7O5kvSA","logo":"_wj8uJ2C","mobile":"mobile"};